var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTimerDefault = function SvgTimerDefault(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    fill: "none",
    viewBox: "0 0 16 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA580C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.417.75v3.333m0 0a6.667 6.667 0 1 0 0 13.334 6.667 6.667 0 0 0 0-13.334ZM5.75.75h3.333m4.472 2.768.884.884M9.615 8.333 7.258 10.69m2.368-2.358L7.27 10.689"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTimerDefault);
export default ForwardRef;